<template>
  <!-- Navigation drawer -->
  <v-navigation-drawer
    v-model="internalDrawer"
    :temporary="mobile"
    :permanent="!mobile"
    theme="dark"
  >
    <NavList />
  </v-navigation-drawer>

  <!-- App bar -->
  <v-app-bar app>
    <v-app-bar-nav-icon
      v-if="mobile"
      variant="text"
      aria-label="Toggle navigation drawer"
      @click.stop="internalDrawer = !internalDrawer"
    />
    <!-- You can add a title or toolbar items here via slot -->
    <slot name="title" />
  </v-app-bar>

  <!-- Main content area with padding -->
  <v-main class="flex-grow-1">
    <slot />
  </v-main>

  <v-footer class="d-flex align-center justify-center">
    <v-btn
      href="https://www.eurekadigital.co"
      variant="plain"
      target="_blank"
    >
      <v-icon class="nf nf-md-heart_flash me-2" />
      by EurekaDigital.Co
    </v-btn>
  </v-footer>
</template>

<script setup>
import { computed } from 'vue';
import NavList from '@/presentation/components/ui/NavList.vue';

// Props for mobile flag and drawer state
const props = defineProps({
  mobile: Boolean,
  drawer: Boolean
});

// Emit for v-model:drawer binding
const emit = defineEmits(['update:drawer']);

// Internal computed to link drawer prop with v-navigation-drawer
const internalDrawer = computed({
  get: () => props.drawer,
  set: (val) => emit('update:drawer', val)
});
</script>
<style scoped>
.v-footer {
  max-height: 3rem;
}
</style>
